import { request } from "utils/legacy_api";

export function subtopics(topic: string) {
  return request(`/study_plan?topic=${topic}`, {
    method: "GET"
  });
}
